/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageBulkCallersDto } from '../../models/usage-bulk-callers-dto';

export interface GetUsageBulkCallers$Params {
  from?: string;
  to?: string;
  'X-API-Version'?: string;
}

export function getUsageBulkCallers(http: HttpClient, rootUrl: string, params?: GetUsageBulkCallers$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBulkCallersDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageBulkCallers.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageBulkCallersDto>;
    })
  );
}

getUsageBulkCallers.PATH = '/api/usage-statistics/bulk-callers';
